import React, { ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const MyGoogleReCaptchaProvider = ({ children }: { children: ReactNode }) => {
  return <GoogleReCaptchaProvider reCaptchaKey={window._env_.REACT_APP_RECAPTCHA_SITE_KEY!}
                                  scriptProps={{ async: true }} children={children} />;
};